import React, { useState, useEffect } from 'react';
import LanguageSelector from './LanguageSelector';
import CurrencySelector from './CurrencySelector';
import './MobileNav.css';

// HOMEPAGE: Sticky top nav with anchor links
export const HomepageMobileNav = ({ onSignIn }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setMenuOpen(false);
  };

  return (
    <nav className={`mobile-topnav ${scrolled ? 'scrolled' : ''}`}>
      <div className="mobile-topnav-inner">
        <div className="mobile-topnav-logo">🎬 VlogClip AI</div>
        <button className="mobile-hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>
      {menuOpen && (
        <div className="mobile-menu-dropdown">
          <button onClick={() => scrollTo('section-how')}>🎯 How It Works</button>
          <button onClick={() => scrollTo('section-platforms')}>📱 Platforms</button>
          <button onClick={() => scrollTo('section-pricing')}>💰 Pricing</button>
          <button onClick={() => scrollTo('section-reviews')}>⭐ Reviews</button>
          <button onClick={() => scrollTo('section-faq-home')}>❓ FAQ</button>
          <LanguageSelector compact />
          <CurrencySelector compact />
          <button onClick={() => { onSignIn(); setMenuOpen(false); }}>✨ Sign In</button>
        </div>
      )}
    </nav>
  );
};

// DASHBOARD: Bottom tab bar
export const DashboardMobileNav = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'overview', icon: '🏠', label: 'Home' },
    { id: 'generate', icon: '⚡', label: 'Create' },
    { id: 'clips', icon: '🎬', label: 'Clips' },
    { id: 'analytics', icon: '📊', label: 'Stats' },
    { id: 'help', icon: '🤖', label: 'AI Help' },
    { id: 'settings', icon: '⚙️', label: 'More' },
  ];

  return (
    <nav className="mobile-bottomnav">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`mobile-bottomnav-tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          <span className="tab-icon">{tab.icon}</span>
          <span className="tab-label">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
};

// ANALYTICS: Floating section pills
export const AnalyticsMobileNav = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="mobile-analytics-nav">
      <button onClick={() => scrollTo('analytics-usage')}>Usage</button>
      <button onClick={() => scrollTo('analytics-performance')}>Performance</button>
      <button onClick={() => scrollTo('analytics-referrals')}>Referrals</button>
      <button onClick={() => scrollTo('analytics-activity')}>Activity</button>
    </div>
  );
};

// FLOATING BACK TO TOP BUTTON (mobile only)
export const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      className="mobile-back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
    >
      ↑
    </button>
  );
};
